module.exports = "https://coursera_assets.s3.amazonaws.com/images/24c92c8ba5d1cf413157fd0599d51236.png";